import { useTranslation } from "react-i18next";
import { normalizeStatus, getStatusLabel } from "../../utils/orderStatus";
import "../../styles/OrderCardBlock.css";

export default function OrderCardBlock({ order }) {
  const { t, i18n } = useTranslation("orders");

  if (!order) return null;

  function formatMoney(value) {
    const n = Number(value || 0);
    const locale = i18n.language?.startsWith("uk") ? "uk-UA" : "en-US";

    return `${new Intl.NumberFormat(locale, {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    }).format(n)} ${t("currency_symbol")}`;
  }

  const items = Array.isArray(order.items) ? order.items : [];

  return (
    <div className="chatOrderCard">
      <div className="chatOrderTop">
        <div className={`chatOrderStatus st-${normalizeStatus(order.status)}`}>
          {getStatusLabel(order.status || "processing")}
        </div>

        <div className="chatOrderTotal">
          {formatMoney(order.total)}
        </div>
      </div>

      <div className="chatOrderMeta">
        {t("order")} №{order.receipt_number || order.id}
        {order.date ? ` • ${order.date}` : ""}
      </div>

      {!!items.length && (
        <div className="chatOrderImages">
          {items.slice(0, 6).map((it, i) => {
            const img = it?.image_url || it?.image_proxy_url || "";

            return (
              <div
                key={it.id ?? `${order.id}-${i}`}
                className="chatOrderImgWrap"
              >
                {img && (
                  <img
                    src={img}
                    alt={it.title || it.name || "item"}
                    loading="lazy"
                  />
                )}
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}